import { idr } from "../../../lib/api";
import { formatTanggal } from "../../../lib/tanggal";

// Laporan hasil impor tanggal aktivasi (brief 22 Sep A6). SETIAP daftar yang
// dikirim backend (`routers/pp/impor_aktivasi.py`) punya barisnya di sini —
// dulu panel hanya membaca `diperbarui` & `gagal`, jadi baris yang ditahan
// untuk konfirmasi timpa tidak pernah terlihat dan toast tetap berbunyi
// "berhasil" (keberatan tes-02). Dijaga tes node `backend/tests/test_pp3_layar.py`.
// Komponen murni (tanpa api/useAuth) supaya bisa dirender tes apa adanya.
export const DAFTAR_HASIL_IMPOR = [
  { kunci: "sudah_diklaim", judul: "Sudah ada di klaim — tanggal tidak diubah", nada: "rose" },
  { kunci: "siklus_lama", judul: "Tanggal milik siklus sebelum unit masuk lagi — tidak ditulis", nada: "rose" },
  { kunci: "ditolak", judul: "Baris ditolak", nada: "rose" },
  { kunci: "tidak_ditemukan", judul: "Unit tidak ditemukan", nada: "rose" },
  { kunci: "berubah_bersamaan", judul: "Diubah proses lain saat impor — impor ulang", nada: "amber" },
  { kunci: "bukan_anggota", judul: "Tanggal tercatat, tetapi unit tidak berada di program ini", nada: "amber" },
  { kunci: "sn_tidak_diisi_izin", judul: "Serial Number tidak diisi — butuh izin Unit & IMEI › Ubah", nada: "amber" },
  { kunci: "sn_gagal", judul: "Serial Number tidak diisi", nada: "amber" },
];

const LABEL_STATUS = {
  eligible: "Eligible", pending_activation: "Menunggu Aktivasi", not_eligible: "Tidak Eligible",
  already_claimed: "Sudah Diklaim",
};

function DaftarBaris({ kunci, judul, nada, baris }) {
  if (!baris || baris.length === 0) return null;
  const warna = nada === "rose" ? "text-rose-700" : "text-amber-700";
  return (
    <div data-testid={`cb-import-daftar-${kunci}`}>
      <p className={`font-medium ${warna}`}>{judul} ({baris.length})</p>
      <div className="max-h-32 overflow-y-auto mt-1">
        <table className="w-full text-[11px]">
          <tbody>
            {baris.map((g, i) => (
              <tr key={`${kunci}-${i}`} className="border-t border-slate-100" data-testid={`cb-import-baris-${kunci}`}>
                <td className="pr-2 py-0.5 font-mono align-top">{g.baris}</td>
                <td className="py-0.5 text-slate-600">{g.imei ? `${g.imei} — ` : ""}{g.alasan}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function HasilImporAktivasi({ hasil, pilihTimpa, onUbahTimpa }) {
  if (!hasil) return null;
  const pratinjau = hasil.mode === "pratinjau";
  const konflik = hasil.perlu_konfirmasi_timpa || [];
  const bisaPilih = pratinjau && typeof onUbahTimpa === "function";
  const semuaDipilih = konflik.length > 0 && konflik.every((k) => pilihTimpa?.has(k.unit_id));
  const ubahSemua = () => onUbahTimpa(semuaDipilih ? [] : konflik.map((k) => k.unit_id));
  const ubahSatu = (id) => {
    const n = new Set(pilihTimpa || []);
    n.has(id) ? n.delete(id) : n.add(id);
    onUbahTimpa([...n]);
  };
  return (
    <div className="space-y-2">
      <p className="text-slate-700" data-testid="cb-import-ringkas">
        {pratinjau
          ? `Pratinjau (belum disimpan): ${(hasil.akan_diperbarui || []).length} tanggal akan dicatat, ${konflik.length} perlu konfirmasi timpa.`
          : `${hasil.diperbarui} tanggal aktivasi diperbarui.`}
        {hasil.tanggal_kosong > 0 ? ` ${hasil.tanggal_kosong} baris tanpa tanggal dilewati.` : ""}
        {hasil.sudah_sama > 0 ? ` ${hasil.sudah_sama} tanggal sudah sama.` : ""}
        {!pratinjau && hasil.sn_diisi > 0 ? ` ${hasil.sn_diisi} Serial Number diisi.` : ""}
        {pratinjau && hasil.sn_akan_diisi > 0 ? ` ${hasil.sn_akan_diisi} Serial Number kosong akan diisi.` : ""}
      </p>
      {pratinjau && (hasil.akan_diperbarui || []).length > 0 && (
        <div data-testid="cb-import-daftar-akan_diperbarui" className="max-h-32 overflow-y-auto">
          <table className="w-full text-[11px]">
            <tbody>
              {hasil.akan_diperbarui.map((a) => (
                <tr key={a.unit_id} className="border-t border-slate-100" data-testid="cb-import-baris-akan_diperbarui">
                  <td className="pr-2 py-0.5 font-mono">{a.baris}</td>
                  <td className="py-0.5 font-mono">{a.imei}</td>
                  <td className="py-0.5 text-slate-600">{formatTanggal(a.baru)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {!pratinjau && (hasil.rincian_diperbarui || []).length > 0 && (
        <div data-testid="cb-import-daftar-rincian_diperbarui" className="max-h-40 overflow-y-auto">
          <table className="w-full text-[11px]">
            <thead className="text-slate-500">
              <tr><th className="text-left pr-2">IMEI</th><th className="text-left pr-2">Tgl Aktivasi</th>
                <th className="text-left pr-2">Program</th><th className="text-left pr-2">Status</th><th className="text-right">Nominal</th></tr>
            </thead>
            <tbody>
              {hasil.rincian_diperbarui.map((r) => (
                <tr key={r.unit_id} className="border-t border-slate-100" data-testid="cb-import-baris-rincian_diperbarui">
                  <td className="pr-2 py-0.5 font-mono">{r.imei}</td>
                  <td className="pr-2 py-0.5">{formatTanggal(r.tanggal_aktivasi)}</td>
                  <td className="pr-2 py-0.5">{r.program_sekarang || "-"}</td>
                  <td className="pr-2 py-0.5">{LABEL_STATUS[r.status] || "-"}</td>
                  <td className="py-0.5 text-right font-mono">{r.cashback_nominal == null ? "-" : idr(r.cashback_nominal)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {(hasil.peringatan || []).length > 0 && (
        <div data-testid="cb-import-peringatan" className="bg-amber-50 border border-amber-200 rounded p-2 text-amber-800">
          {hasil.peringatan.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      )}
      {hasil.nominal_tidak_dihitung && (
        <p className="text-amber-700" data-testid="cb-import-nominal-gagal">
          Tanggal tersimpan, tetapi nominal belum bisa dihitung ulang: {hasil.nominal_tidak_dihitung}
        </p>
      )}
      {konflik.length > 0 && (
        <div data-testid="cb-import-daftar-perlu_konfirmasi_timpa">
          <p className="font-medium text-amber-700">
            Tanggal tercatat BERBEDA dengan berkas ({konflik.length}) — {bisaPilih ? "centang yang benar-benar ingin ditimpa" : "tidak ditimpa"}
          </p>
          {bisaPilih && (
            <label className="text-[11px] text-slate-600 inline-flex items-center gap-1 mt-1">
              <input type="checkbox" data-testid="cb-import-timpa" checked={semuaDipilih} onChange={ubahSemua} />
              Timpa semua baris di bawah
            </label>
          )}
          <div className="max-h-32 overflow-y-auto mt-1">
            <table className="w-full text-[11px]">
              <tbody>
                {konflik.map((k) => (
                  <tr key={k.unit_id} className="border-t border-slate-100" data-testid="cb-import-baris-perlu_konfirmasi_timpa">
                    {bisaPilih && (
                      <td className="pr-2 py-0.5">
                        <input type="checkbox" data-testid={`cb-import-timpa-${k.unit_id}`}
                               checked={!!pilihTimpa?.has(k.unit_id)} onChange={() => ubahSatu(k.unit_id)} />
                      </td>
                    )}
                    <td className="pr-2 py-0.5 font-mono">{k.imei}</td>
                    <td className="py-0.5 text-slate-600">tercatat {formatTanggal(k.tercatat)} → berkas {formatTanggal(k.berkas)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {DAFTAR_HASIL_IMPOR.map((d) => (
        <DaftarBaris key={d.kunci} kunci={d.kunci} judul={d.judul} nada={d.nada} baris={hasil[d.kunci]} />
      ))}
    </div>
  );
}
